<template>
	<!-- #reigon 短攻略发布按钮 -->
	<!-- <vue-draggable-resizable :resizable="false" :w="50" :h="50" class="drag_entry" :x="100" :y="100"> -->
	<a href="javascript:;" @click="toSubmit" class="ig--submit_entry" :style="{'background-color': mColor(14)}">
	    <sui-icon :fill="mColor(16)" class="submit_icon" name="edit"></sui-icon>
	</a>
	<!-- </vue-draggable-resizable> -->
	<!-- #endregion -->
</template>

<script>

import mCore from '../../scripts/mixins/core'

export default {
	name: 'igc-submit-entry',
	mixins: [mCore],
	
	computed: {
	},
	props: {
		id: [Number, String]
	},
	methods: {
		toSubmit(){
			if(!window.__UgcConfig.shortStrategy){
				alert(window.__UgcConfig.tips);
				return ;
			}
			this.$router.push({
				path: this.id?`/submit/${this.id}`:'/submit'
			})
        }
	}
}

</script>

<style lang="postcss">
	.ig--submit_entry {
		position: fixed;
		right: 5%;
		bottom: 10%;
	    width: 70px;
	    height: 70px;
	    border-radius: 50%;
	    display: flex;
	    justify-content: center;
	    align-items: center;
	    
	    .submit_icon {
	        width: 42px;
	        height: 42px;
	    }
	}
</style>